/* globals axios route moment */
import ErrorHandler from '../core/ErrorHandler';

export default {
  created() {
    axios
      .get(route('api.failedJobs.show', this.failedJobId))
      .then(({ data }) => this.setFailedJob(data.data))
      .catch(() => this.setFailedJob(null));
  },

  computed: {
    recurrence() {
      return this.data.data.recurrence;
    },

    product() {
      return this.data.data.product;
    },

    failedJobId() {
      return this.data.data.failedJobId;
    },

    timeLeftToRegenerate() {
      if (!this.failedJob) {
        return false;
      }
      const expireOn = moment(this.failedJob.failed_at).add(3, 'days');
      return expireOn.isBefore() ? false : expireOn.fromNow(true);
    },

    allowedToRegenerate() {
      return this.failedJob && this.timeLeftToRegenerate;
    },
  },

  data() {
    return {
      status: null,
      failedJob: null,
    };
  },

  methods: {
    setFailedJob(boolean) {
      this.failedJob = boolean;
    },

    async regenerate() {
      this.status = 'loading';

      if (!await this.canRegenerate()) {
        this.cannotRegenerateHook();
        return this.onFail();
      }

      try {
        await this.retryJob();
        return this.onSuccess();
      } catch (error) {
        new ErrorHandler(error).dispatch();
        return this.onFail();
      }
    },

    canRegenerate() {
      return false;
    },

    cannotRegenerateHook() {
      //
    },

    afterSuccessHook() {
      //
    },

    retryJob() {
      return axios.patch(route('api.failedJobs.update', this.failedJobId));
    },

    onSuccess() {
      this.status = 'succeeded';
      setTimeout(() => {
        this.status = null;
        this.afterSuccessHook();
      }, 1500);
    },

    onFail() {
      this.status = 'failed';
      setTimeout(() => {
        this.status = null;
      }, 1500);
    },
  },
};
